module.exports = "/_next/static/images/instrument_2-28591c54d01b6b589508c55eeefc3752.png";